import { axiosBase, errorHandler } from "./axios";

const termsAndCondition = (input?: { role?: string }) => {
  const roleQuery = input?.role ? `?role=${input.role}` : "";
  return axiosBase
    .get(`/api/v1/termsAndCondition/active${roleQuery}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getByType = (type: "terms_and_conditions" | "privacy_policy") => {
  return axiosBase
    .get(`/api/v1/termsAndCondition`, { params: { type } })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const termsAndConditionService = {
    termsAndCondition,
    getByType,
};